import { useEffect, useMemo, useRef, useState } from "react";
import { Chart } from "chart.js";

import { useMediaQuery } from "@mui/material";

import { PaperChartCustom } from "../../../../Theme/ContainerStyle"
import TooltipChart from "./TooltipChart";
import { linePlugin } from "./PluginHACCP";

////OPZIONI BASE DEL GRAFICO CHE NON HANNO BISOGNO DI ESSERE AGGIORNATE
///AD OGNI RENDER
const chartOptions = {
  interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false // Permette di considerare le linee vicine e non solo i punti
  },
  scales: {
    x: {
      type: "time",
      time: {
        displayFormats: {quarter: "dd MMM"},
       tooltipFormat:"dd/MM/yyyy HH:mm",
      }
    }
  },
  plugins: {
    legend: {display: false},
    tooltip: {
      mode: "nearest",
      position: "custom",
      intersect: false,
      enabled: false,
      callbacks: {
        title(tooltipItems) {
          return "Data: " + tooltipItems[0].label;
        }
      },
    },
  },
};

export default function ChartLine(props) {
  const {dateRange, datasets, openMap, mapExist, titleTooltip} = props
  const currentDataset = datasets.find(data => data.name === "currentData").dataset;
  const canvas = useRef(null);
  const chart = useRef(null);
  const [tooltip, setTooltip] = useState({show: false});
  const [lineIndex, setLineIndex] = useState()  
  const sizeMedia = useMediaQuery('(min-width:800px)');
  /// SIZE FA SI CHE IL GRAFICO SI ADATTI IN BASE AL DISPOSITIVO UTILIZZATO E SE 
  /// LA MAPPA è APERTA O
  ///CHIUSA, USO UN USEMEMO PER GARANTIRE CHE IL VALORE NON CAMBI AD OGNI RENDER
  ///A MENO CHE NON CAMBI VERAMENTE OPENMAP
  
  const size = useMemo(() => {
    if (sizeMedia === true) {
      if (mapExist) {
        if (openMap === false) {
          return {
            maintainAspectRatio: true,
            aspectRatio: 3,
          };
        }
      } else {
        return {
          maintainAspectRatio: true,
          aspectRatio: 3,
        };
      } 
    } else {
      return {
        maintainAspectRatio: false,
        aspectRatio: 1,
      }
    }
  },[openMap, mapExist,sizeMedia])

// Funzione per gestire il clic sul grafico
const handleChartClick = (event) => {
  const points = chart.current.getElementsAtEventForMode(event, 'nearest', { intersect: false }, false);

  if (points.length) {
    const idLineClicked = points[0].datasetIndex;

    // Modifica lo spessore della linea specifica
    chart.current.data.datasets.forEach((dataset, index) => {
      dataset.borderWidth = index === idLineClicked ? 5 : 2; 
    });
    setLineIndex(idLineClicked)
    // Aggiorna il grafico usando l'opzione lazy per evitare il rendering del grafico 
    chart.current.update('none', {
      lazy: true,
      duration: 0, // Disabilita le animazioni per rendere il cambio immediato
    });
  }
};

  ///USEEFFECT CHE SI OCCUPA DI CREARE IL GRAFICO E ANCHE DI RIPULIRE IL
  ///CHART.CURRENT UNA VOLTA CREATO E VISUALIZZATO
  useEffect(() => {
    if (chart.current) {
      chart.current.data.labels = dateRange;
      chart.current.data.datasets = currentDataset;
      chart.current.options.scales = chartOptions.scales;
      chart.defaults.elements.line = 20;
      chart.current.update();
      
    } else {
      const updatedDataset = currentDataset.map(dataset => ({
        ...dataset,
        spanGaps: false // Imposta spanGaps su false per ciascun dataset
      }));
      chart.current = new Chart(
        canvas.current,
        {
          type: "line",
          data: {
            labels: dateRange,
            datasets: updatedDataset,
          },
          plugins: [linePlugin()],
          options: {
            ...chartOptions,
            ...size,
            spanGaps: false,
            plugins: {
              ...chartOptions.plugins,
              tooltip: {
                ...chartOptions.plugins.tooltip,
                external(context) {
                  // Hide if no tooltip
                  const tooltipModel = context.tooltip;
                  if (tooltipModel.opacity === 0) {
                    setTooltip({
                      show: false,
                    });
                    return;
                  }

                  const {offsetLeft: positionX, offsetTop: positionY} = context.chart.canvas;

                  setTooltip({
                    show: true,
                    top: positionY + tooltipModel.caretY + 'px',
                    left: positionX + tooltipModel.caretX + 'px',
                    title: tooltipModel.title,
                    body: tooltipModel.body.map(bodyItem => bodyItem.lines),
                    colors: tooltipModel.labelColors,
                  });
                }
              }
            }
          }
        }
      );

      // Aggiunge l'event listener per il clic
      canvas.current.addEventListener('click', handleChartClick);
    }

    return () => {
      if (chart.current) {
        chart.current.destroy();
        chart.current = null;
      }
      if (canvas.current) {
        canvas.current.removeEventListener('click', handleChartClick);
      }
    };
  }, [dateRange, currentDataset, size]); 

  const propsTooltip = {tooltip, lineIndex, titleTooltip,sizeMedia}

  return (
    <>
      <PaperChartCustom className={"chart-area"}>
        <canvas ref={canvas} />
      </PaperChartCustom>
      <TooltipChart {...propsTooltip}/>
    </>
  );
}
